import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { useTheme } from '../../context/ThemeContext';

const Layout = ({ children, showHeader = true, hideHeaderOnQuiz = false }) => {
  const location = useLocation();
  const { isDark } = useTheme();

  // These routes have their own complete layouts with sidebars/headers
  const routesWithOwnLayout = ['/quiz-app', '/mock-test', '/'];
  const hasOwnLayout = routesWithOwnLayout.includes(location.pathname);

  return (
    <Fragment>
      <main className={`transition-colors duration-300 min-h-screen ${isDark ? 'bg-dark-primary' : 'bg-gray-50'}`}>
        {children}
      </main>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  showHeader: PropTypes.bool,
  hideHeaderOnQuiz: PropTypes.bool,
};

export default Layout;
